import { useTranslation } from 'react-i18next';

export default function CompanyStats() {
  const { t } = useTranslation();

  const stats = [
    { numKey: 'stat1_num', labelKey: 'stat1_label', subKey: 'stat1_sub' },
    { numKey: 'stat2_num', labelKey: 'stat2_label', subKey: 'stat2_sub' },
    { numKey: 'stat3_num', labelKey: 'stat3_label', subKey: 'stat3_sub' },
    { numKey: 'stat4_num', labelKey: 'stat4_label', subKey: 'stat4_sub' },
  ];

  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <div
              key={stat.labelKey}
              className={`text-center p-6 md:p-8 rounded-2xl ${
                i === 0 ? 'bg-[#C8714A] text-white' : 'bg-[#faf8f5]'
              }`}
            >
              <div
                className={`text-3xl md:text-4xl font-black mb-1 ${
                  i === 0 ? 'text-white' : 'text-[#C8714A]'
                }`}
              >
                {t(stat.numKey)}
              </div>
              <div
                className={`text-sm font-semibold mb-1 ${
                  i === 0 ? 'text-white/90' : 'text-[#1a1a1a]'
                }`}
              >
                {t(stat.labelKey)}
              </div>
              <div
                className={`text-xs ${i === 0 ? 'text-white/65' : 'text-[#999]'}`}
              >
                {t(stat.subKey)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
